export const POLLING_INTERVAL_MS =
  Number(process.env.REACT_APP_POLLING_TIME) || 60000;
